import { render } from "./PageAside.vue?vue&type=template&id=fbe55850&scoped=true"
import script from "./PageAside.vue?vue&type=script&lang=js"
export * from "./PageAside.vue?vue&type=script&lang=js"

import "./PageAside.vue?vue&type=style&index=0&id=fbe55850&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe55850"]])

export default __exports__